<template>
  <div class="page-wrapper">
    <AppHeader title="Customers" />
      <div class="container-fluid">
        <div class="row topnav" style="padding-left: 15px;">      
            <!-- <div class="col-sm-1">
              <div class="dropdown" style="position:fixed;left:0;top:0;padding:0;margin-top:0;margin-bottom:0">
                <MainMenu/>
              </div>          
            </div> -->
            <div class="col-sm-12">          
            <div v-show="showError" style="text-align:center">
              <label class="h3" style="color:maroon"> {{this.mainErrorMsg}} </label>
            </div>
          </div>  
        </div>    
        <div v-if="showAddCustomer" class="container no-scrollbar" style="width: 80%; background-color: var(--form-color); padding: 20px; border-radius: 10px; margin-bottom: 20px; max-height: 80vh; overflow-y: auto; box-shadow: 0 10px 30px rgba(0,0,0,0.3);">
          <div class="row" style="color: #fff;">
            
            <!-- TIN Number -->
            <div v-if="AddCustomer" class="col-md-12 mb-3">
              <label title="tin_number" class="form-label" style="font-size: 1.2em;">TIN Number</label>
              <div class="input-groups">
                <input type="number" v-model="tin" class="form-control" style="font-size: 1.2em;">
                <!-- <button class="btn btn-primary" @click="getCustomerByTin()" style="font-size: 1.2em;">Find</button> -->
              </div>
            </div>

            <!-- Customer Name & Business Name -->
            <div class="col-md-6 mb-3">
              <label title="Customer name" class="form-label" style="font-size:1.2em">{{jsonData.customer_name}}</label>
              <input type="text" v-model="name" class="form-control" style="font-size:1.2em" :disabled="!isDisabledtin" />
            </div>
            <div class="col-md-6 mb-3">
              <label title="Business name" class="form-label" style="font-size:1.2em">{{jsonData.business_name}}</label>
              <input type="text" v-model="business_name" class="form-control" style="font-size:1.2em" />
            </div>

            <!-- Email & Mobile -->
            <div class="col-md-6 mb-3">
              <label title="Customer email" class="form-label" style="font-size:1.2em">{{jsonData.customer_email}}</label>
              <input type="text" v-model="email" class="form-control" style="font-size:1.2em" />
            </div>
            <div class="col-md-6 mb-3">
              <label title="Customer mobile" class="form-label" style="font-size:1.2em">{{jsonData.customer_mobile}}</label>
              <input type="text" v-model="phone" class="form-control" style="font-size:1.2em" />
            </div>

            <!-- Customer Type -->
            <div class="col-md-6 mb-3">
              <label class="form-label" style="font-size:1.2em; display:block">Customer Type</label>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="customer_type" id="option1" :checked="type == 'Customer'" value="Customer" style="transform: scale(1.5);">
                <label class="form-check-label" for="option1" style="font-size: 1.2em; margin-left: 5px; margin-right: 15px;">Customer</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="customer_type" id="option2" :checked="type == 'Business'" value="Business" style="transform: scale(1.5);">
                <label class="form-check-label" for="option2" style="font-size: 1.2em; margin-left: 5px;">Business</label>
              </div>
            </div>

            <!-- Discount Percentage -->
            <div class="col-md-6 mb-3">
              <label title="Discount Percentage" class="form-label" style="font-size:1.2em">Discount Percentage</label>
              <input type="text" v-model="dis_percentage" class="form-control" style="font-size:1.2em" />
            </div>

            <!-- Address Line 1 & 2 -->
            <div class="col-md-6 mb-3">
              <label title="Address Line 1" class="form-label" style="font-size:1.2em">{{jsonData.address_line1}}</label>
              <input type="text" v-model="addressLine1" class="form-control" style="font-size:1.2em" />
            </div>
            <div class="col-md-6 mb-3">
              <label title="Address Line 2" class="form-label" style="font-size:1.2em">{{jsonData.address_line2}}</label>
              <input type="text" v-model="addressLine2" class="form-control" style="font-size:1.2em" />
            </div>

            <!-- Address Area & City -->
            <div class="col-md-6 mb-3">
              <label title="Address area" class="form-label" style="font-size:1.2em">{{jsonData.address_area}}</label>
              <input type="text" v-model="addressArea" class="form-control" style="font-size:1.2em" />
            </div>
            <div class="col-md-6 mb-3">
              <label title="Address city" class="form-label" style="font-size:1.2em">{{jsonData.address_city}}</label>
              <input type="text" v-model="addressCity" class="form-control" style="font-size:1.2em" />
            </div>

            <!-- Checkboxes -->
            <div class="col-md-6 mb-3 d-flex align-items-center">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="default_address" style="transform: scale(1.5);">
                <label class="form-check-label" for="default_address" style="font-size:1.2em; margin-left:10px">{{jsonData.address_default}}</label>
              </div>
            </div>
            <div class="col-md-6 mb-3 d-flex align-items-center">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="creditstatuscheck" style="transform: scale(1.5);">
                <label class="form-check-label" for="creditstatuscheck" style="font-size:1.2em; margin-left:10px">{{jsonData.credit_status}}</label>
              </div>
            </div>

            <!-- Buttons -->
            <div class="col-md-12 text-right mt-3">
              <button class="btn btn-success mr-4" v-if="customerid ===0" style="font-size:1.5em" @click="createCustomer">Save</button>
              <button class="btn btn-success mr-4" v-if="customerid !==0" style="font-size:1.5em" @click="updateCustomer">Update</button>
              <span style="display:inline-block;width:1.5rem;"></span>
              <button class="btn btn-danger" style="font-size:1.5em" @click="cancelSaveCustomer">Cancel</button>
            </div>

          </div>
        </div>  
        <div v-if="toggle">
          <div class="touch-search-header">
            <div class="touch-search-area">
              <div v-if="hasPermission(22)" class="input-group touch-search-group">
                <span class="input-group-addon">
                  <i class="glyphicon glyphicon-search"></i>
                </span>
                <input
                  type="text"
                  v-model="findcustomer"
                  class="form-control input-lg"
                  placeholder="Search customer"
                  @keyup.enter="findCustomerByCond()"
                >
                <span class="input-group-btn">
                  <button
                    class="btn btn-success btn-lg"
                    @click="findCustomerByCond()"
                  >
                    Search
                  </button>
                </span>
              </div>
            </div>
            <div class="touch-search-actions">
              <button
                v-if="hasPermission(21)"
                class="btn btn-success btn-lg"
                @click="handleAddCustomer"
              >
                New customer
              </button>
            </div>
          </div>

          <br>

          <div  v-if="toggle" class="table-wrap" style="color: #fff;">
            <table class="table"  style="color: #fff;">
              <thead>
                <tr>
                  
                  <th  style="font-size:1em">Customer name</th>
                  <th  style="font-size:1.1em">Customer tin</th>
                  <th  style="font-size:1.1em">Phone</th>
                  <th  style="font-size:1.1em">City</th>
                  <th  style="font-size:1.1em">Address</th>
                  <th  style="font-size:1.1em">Points</th>
                  <th  style="font-size:1.1em"><div v-show="reports_ok">Balance</div></th>
                  <th  style="font-size:1.1em"> </th>
                  <th  style="font-size:1.1em"> </th>
                  <th  style="font-size:1.1em"> </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="customer in customers" :key="customer.id">
                  <td style="font-size:1.1em">{{customer.name}}</td>
                  <td style="font-size:1.1em">{{customer.customer_tin}}</td>
                  <td style="font-size:1.1em">{{customer.phone}}</td>
                  <td style="font-size:1.1em">{{customer.city}}</td>
                  <td style="font-size:1.1em">{{customer.line1}}</td>
                  <td style="font-size:1.1em">{{formatNumber(customer.totalpoints)}}</td>
                  <td style="font-size:1.1em"><div v-show="reports_ok">{{customer.balance}}</div></td>
                  <td><button v-if="hasPermission(23)"  class="btn btn-success" style="font-size:1em" @click="editCustomer(customer.id)">Details</button></td>
                  <!-- <td><button v-if="hasPermission(24)"  class="btn btn-success" style="font-size:1em" @click="findCustomerInvoices(customer)">Invoices</button></td> -->
                  <td><button v-if="hasPermission(25)"  class="btn btn-success" style="font-size:1em" @click="findCustomerInvoices(customer)">SOA</button></td>
                  <td><button v-if="hasPermission(69)"  class="btn btn-primary" style="font-size:1em" @click="createGiftCard(customer)">Create GiftCard</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div  v-if="showInvoices" style="color: #fff; ">
          <div style="display:flex; justify-content:flex-end; width:100%; margin-bottom:10px;">
              <button class="btn btn-success" style="font-size:1.5em" @click="printCustomerSoa()">Print</button>
                          <span style="display:inline-block;width:1.5rem;"></span>
              <button class="btn btn-danger" style="font-size:1.5em" @click="showCustomers()">Cancel</button>
          </div>
<div class="customers-wrapper">

  <div
    v-for="customer in selectedcustomers"
    :key="customer.id"
    class="customer-card"
  >
    <div class="customer-grid">

      <div class="customer-item">
        <span class="label">Customer Name</span>
        <span class="labels">{{ customer.name }}</span>
      </div>

      <div class="customer-item">
        <span class="label">Customer TIN</span>
        <span class="labels">{{ customer.customer_tin }}</span>
      </div>

      <div class="customer-item">
        <span class="label">Phone</span>
        <span class="labels">{{ customer.phone }}</span>
      </div>

      <div class="customer-item">
        <span class="label">City</span>
        <span class="labels">{{ customer.city }}</span>
      </div>

      <div class="customer-item">
        <span class="label">Address</span>
        <span class="labels">{{ customer.line1 }}</span>
      </div>

      <div
        v-show="reports_ok"
        class="customer-item balance"
      >
        <span class="label">Balance</span>
        <span class="labels">{{ customer.balance }}</span>
      </div>

    </div>
  </div>

</div>
            <br>
            <table class="table"  style="color: #fff;">
              <thead>
                <tr>
                    <th  style="font-size:1.5em;text-align: left;">Date</th>
                  <th  style="font-size:1.5em;text-align: left;">Invoice No</th>
                  <th  style="font-size:1.5em;text-align: left;">Debit</th>
                  <th  style="font-size:1.5em;text-align: left;">Credit</th>
                  <th  style="font-size:1.5em;text-align: right;">Balance(Dr-Cr)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in customer_invoices" :key="invoice.invoice">
                    <td style="font-size:1.5em;text-align: left;">{{invoice.day_added}}</td>
                  <!-- <td  style="font-size:1.5em;text-align: left;">{{invoice.invoice}}</td> -->
                  <td style="cursor: pointer;font-size:1.5em;text-align: left;" @click="goToFindInvoice(invoice.invoice)">{{invoice.invoice}}</td>
                  <td style="font-size:1.5em;text-align: right;">{{invoice.Debit != 0 ?  formatNumber(invoice.Debit) : '-'}}</td>
                  <td style="font-size:1.5em;text-align: right;">{{invoice.Credit != 0? formatNumber(invoice.Credit) : '-'}}</td>
                  <td style="font-size:1.5em;text-align: right;">{{balances[index+1] != 0 ? formatNumber(balances[index+1]) : '-'}}</td>
              
                </tr>
                <tr>
                  <td style="font-size:1.5em;text-align: left;">Total Amounts</td>
                  <td style="font-size:1.5em;text-align: left;"></td>
                  <td style="font-size:1.5em;text-align: left;"></td>
                  <td style="font-size:1.5em;text-align: left;"></td>
                  <td style="font-size:1.5em;text-align: right;">{{balances[balances.length - 1]!=0?formatNumber(balances[balances.length - 1]):'-'}}</td>
                
                </tr>

              </tbody>
            </table>
        </div>

        <PointsToGiftCard :customerId="activeCustomer.id" :pointsAmount="activeCustomer.totalpoints" :open="isToGiftCardOpen" @getSuccess="setToGiftCard($event)"
        @close="isToGiftCardOpen = !isToGiftCardOpen" />

    </div>

</div>
</template>

<script>

  import numericpad from "@/components/SimpleKeyboard";

  import { ref } from "vue"
  import axios from "axios";
  import router from '@/router';
  import commonServices from "@/shared/commonServices"
  import AppHeader from "@/components/AppHeader";
  import PointsToGiftCard from "../components/PointsToGiftCard.vue";
  import FindInvoice from "../views/FindInvoice.vue";


  export default {
    mixins: [commonServices],
    setup(){
      const isToGiftCardOpen = ref(false);
      return {
        isToGiftCardOpen
      }
    },
    computed() {
      
    },
    mounted() {
      console.log(this.disabled);
      this.isDisabledtin();
      if(localStorage.reports_ok === "1"){
        this.reports_ok = true;
      }
      this.findCustomerByCond();
      if(localStorage.userId!==undefined && localStorage.appId !== undefined){
      }else{
        this.$router.push({ name: 'login'});
      }
      this.language = 'ar';
      this.handleLanguage();
      this.getLogo();
      this.logoImage = '<img src="'+this.logoUrl+'" width="70" height="50" alt="Logo">';
    },    
    components:{ AppHeader, PointsToGiftCard },
    data: function(){
        return {
          payments_total: 0,
          activeCustomer: {id: 0, totalpoints: 0},
          invoices_total: 0,
          tin: '',
          type: '',
          order_id: 0,
          isDisabled: false,
          reports_ok: false,
          disabled: false,
          showError: false,
          logoImage: '',
          mainErrorMsg: '',
          logoUrl:'',
          jsonData: {},
          language: 'en',
          languageName: '',
          toggle: true,
          showInvoices: false,
          showPayments: false,
          customers:[],
          addresses:[],
          selectedcustomers: [],
          customer_invoices: [],
          customer_payments: [],
          balances: [0],
          showAddCustomer: false,
          AddCustomer: false,
          isFindInvoiceOpen: false,
          customerJson: {},
          customersJson: {},
          name: '',
          business_name: '',
          gender: '',
          email: '',
          phone: '',
          totalpoints: '',
          dis_percentage: '',
          status: '',
          creditstatus: '',
          date_added: '',
          aaddressid: 0,
          addressLine1: '',
          addressLine2: '',
          addressArea: '',
          addressCity: '',
          isDefault: false,
          customerAddresses:[],
          showAddress:false,
          findcustomer:'',
          findcustomername:'',
          customerInfos: {},
          customeraddress: {},
          customerid:0,
          
        }
    },
    methods:{
      createGiftCard(customer){
        this.activeCustomer = customer;
        this.isToGiftCardOpen = true;
      },
      setToGiftCard(event){
        if(event){
          this.showSuccess("Created GiftCard Successfully");
          this.findCustomerByCond()
        }
      },
    editCustomer(customerid) {
      //this.getCustomerAddresses(customerid);
      this.getCustomer(customerid);

      
    },
    goToFindInvoice(invoiceNumber) {
    this.$router.push({ name: 'find', params: { invoiceNumber } });
  },
    isDisabledtin() {
          return this.disabled;
        },
    printCustomerSoa (){
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      let reportDate = year+"-"+month+"-"+day;
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let reportHeader =  this.selectedcustomers[0].name + "'s Statment Of Accounts";
      let reportFooter = "Printed on: "+year+"-"+month+"-"+day+ " "+time;
      this.printInvoices(reportDate, reportHeader, reportFooter, this.customer_invoices, this.balances[this.balances.length - 1])      
    },
    
    printInvoices(reportDate, reportHeader, reportFooter, customer_invoices, invoices_total){
    
          let viaInvStr = '<table width="100%">';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td  align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportHeader+'</p></b></td></tr></table>'; 
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="100%"  style="border-bottom: #000000 2px solid;"><tr><td align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td align="left"><b><p style="font-size:1.5em">'+reportDate+ '</p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="100%">';
          viaInvStr = viaInvStr + '<tr><td align="left"><b><p style="font-size:1.5em">Date</p></b></td><td align="left"><b><p style="font-size:1.5em">Invoice No</p></b></td><td align="left"><b><p style="font-size:1.5em">Debit</p></b></td><td align="right"><b><p style="font-size:1.5em">Credit</p></b></td><td align="center"><b><p style="font-size:1.5em">Balance(Dr-Cr)</p></b></td></tr>';
          let _this = this;
          for(let  i = 0; i < customer_invoices.length ; i++){
            const item = customer_invoices[i];
            viaInvStr = viaInvStr + '<tr>';
              viaInvStr = viaInvStr + '<td align="left"><p style="font-size:1.5em">'+item.day_added+'</p></td>';
              viaInvStr = viaInvStr + '<td align="left"><p style="font-size:1.5em">'+item.invoice+'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+(item.Debit != 0 ? this.formatNumber(item.Debit) : '-') +'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+ (item.Credit != 0? this.formatNumber(item.Credit): '-') +'</p></td>';
              viaInvStr = viaInvStr + '<td align="right"><p style="font-size:1.5em">'+(this.balances[i+1] != 0 ? this.formatNumber(this.balances[i+1]) : '-') +'</p></td>';
              viaInvStr = viaInvStr + '</tr>';
          }       
          viaInvStr = viaInvStr + '<tr>';
              viaInvStr = viaInvStr + '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1.5em">Total Amounts</p></td>';
              viaInvStr = viaInvStr + '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1.5em"></p></td>';
              viaInvStr = viaInvStr + '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1.5em"></p></td>';
              viaInvStr = viaInvStr + '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="left"><p style="font-size:1.5em"></p></td>';
              viaInvStr = viaInvStr + '<td style="border-top: #000000 2px solid; vertical-align:bottom" align="right"><p style="font-size:1.5em">'+(invoices_total != 0 ? _this.formatNumber(invoices_total) : '-')+'</p></td>';
              viaInvStr = viaInvStr + '</tr>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '</table>';

          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportFooter+'</p></b></td></tr></table>'; 
          viaInvStr = viaInvStr + '</td></tr>';

          viaInvStr = viaInvStr + '</table>';
          this.sharedPrintElemmRep(viaInvStr);

      },


    getCustomer: async function(id){
      this.customerJson = {
        appId: localStorage.appId,
        customer: id
      };
      try{
          let dataURL = this.apiURL+'Customers/getCustomer';

          let response = await axios.post(dataURL, this.customerJson);  
          if(response.data.status === 'success'){
            this.customerInfos = response.data.customer;
            this.customerid = this.customerInfos.id;
            this.name = this.customerInfos.name;
            this.business_name = this.customerInfos.business_name;
            this.type = this.customerInfos.customer_type;
            this.tin = this.customerInfos.customer_tin;
            //this.gender = this.customerInfos.gender;
            
            //this.$el.querySelector('#gender').value = this.customerInfos.gender;
            //this.$el.querySelector('#gender').focus = true;
            this.email = this.customerInfos.email;
            this.phone = this.customerInfos.phone;
            this.getCustomerAddresses(this.customerid);
            this.toggle = false;
            this.showAddCustomer = true;
          }
      }
      catch (error){
          console.log(error);
      }
    }, 

    handleAddCustomer: async function(){
        this.customerAddresses[0]={};
        this.customerInfos = {};
          this.name = '';
          this.business_name = '';
          this.gender = '';
          this.email = '';
          this.phone = '';
          this.dis_percentage = '';
          this.addressLine1 = '';
          this.addressLine2 = '';
          this.addressArea = '';
          this.addressCity = '';
          this.isDefault = false;
          this.customerid = 0;
          this.addressid = 0;
      
        this.showError= false;
        this.mainErrorMsg = "";
        this.showAddCustomer = true;
        this.AddCustomer = true;
        this.toggle = false;
    },   

  getCurrentDateTime(){
    let dateTimeStr = '';
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      dateTimeStr = year+'-'+month+'-'+day+' '+time;
    return dateTimeStr;
  },
    cancelSaveCustomer(){
                this.toggle = true;
                this.showAddCustomer = false;
    },
    
    updateCustomer: async function(){
      //let customerJson = {};      
      this.date_added = this.getCurrentDateTime();

      this.customerJson.appId = localStorage.appId;
      this.customerJson.customerid = this.customerInfos.id;
      this.customerJson.name = this.name;
      this.customerJson.business_name = this.business_name;
      this.customerJson.customer_type = this.type;
      this.customerJson.customer_tin = this.tin;
      
      this.customerJson.gender = this.gender;
      this.customerJson.email = this.email;
      //this.customerJson.totalpoints = this.totalpoints;
      this.customerJson.phone = this.phone;
      this.customerJson.status = this.status;
      this.customerJson.creditstatus = this.$el.querySelector('#creditstatuscheck').checked;
      //this.customerJson.date_added = this.date_added;
      //this.customerJson.created_by = localStorage.userId;
      this.customerJson.line = this.addressLine1;
      this.customerJson.addressid = this.addressid;
      this.customerJson.line1 = this.addressLine2;
      this.customerJson.area = this.addressArea;
      this.customerJson.city = this.addressCity;
      this.customerJson.is_default = this.isDefault;
      let customerJson_ = JSON.stringify(this.customerJson);
      try{
          let dataURL = this.apiURL+'Customers/updateCustomerDefault';
          let response = await axios.post(dataURL, customerJson_);  
          if(response.data.status === 'success'){
            this.customerInfos = {};
            this.customerAddresses[0] = {};
            this.toggle = true;
            this.showAddCustomer = false;
            this.showSuccess('Customer Updated Successfully');
            this.findCustomerByCond()
          }else{
            this.showAlert("Customer Update Failed");
          }
      }
      catch (error){
          console.log(error);
          this.showAlert("Customer Update Failed");
      }
    }, 


    saveCustomer: async function(){
      //let customerJson = {};      
      this.date_added = this.getCurrentDateTime();

      this.customerJson.appId = localStorage.appId;
      this.customerJson.name = this.name;
      this.customerJson.business_name = this.business_name;
      this.customerJson.customer_type = this.type;
      this.customerJson.customer_tin = this.tin;
      this.customerJson.gender = this.gender;
      this.customerJson.email = this.email;
      this.customerJson.totalpoints = this.totalpoints;
      this.customerJson.phone = this.phone;
      this.customerJson.status = this.status;
      this.customerJson.creditstatus = this.$el.querySelector('#creditstatuscheck').checked;
      this.customerJson.date_added = this.date_added;
      this.customerJson.created_by = localStorage.userId;
      this.customerJson.dis_percentage = this.dis_percentage;

      let addressJson = {};
      //addressJson.creditstatus = this.$el.querySelector('#creditstatus').checked;
      addressJson.addressLine1 = this.addressLine1;
      addressJson.addressLine2 = this.addressLine2;
      addressJson.addressArea = this.addressArea;
      addressJson.addressCity = this.addressCity;
      addressJson.isDefault = this.$el.querySelector('#default_address').checked;

      let addressArray = [];
      addressArray.push(addressJson)
      this.customerJson.addresses = addressArray;
      
      let customerJson_ = JSON.stringify(this.customerJson);
      try{
          
          let dataURL = this.apiURL+'Customers/createCustomer';

          let response = await axios.post(dataURL, customerJson_);  
          if(response.data.status === 'success'){
            this.customerInfos = response.data.results;
            this.toggle = true;
            this.showAddCustomer = false;
          this.name = '';
          this.business_name = '';
          this.customer_type = '';
          this.gender = '';
          this.email = '';
          this.phone = '';
          this.dis_percentage = '';
          this.addressLine1 = '';
          this.addressLine2 = '';
          this.addressArea = '';
          this.addressCity = '';
          this.isDefault = false;
            this.showSuccess('Customer Created Successfully');
            this.findCustomerByCond()
            
          }else{
            this.showAlert("Customer Creation Failed \n" + response.data.error);
          }
      }
      catch (error){
        this.showAlert("Customer Creation Failed");

          console.log(error);
      }
    }, 


    createCustomer: async function(){
      this.customersJson.appId = localStorage.appId;
      this.customersJson.phone = this.phone;
      try{
          let dataURL = this.apiURL+'Customers/checkCustomerPhone';
          let response = await axios.post(dataURL, this.customersJson);  
          if(response.data.status === 'success'){
            if(response.data.results.customers.length > 0){
              this.showAlert("Phone number alredy exist : "+response.data.results.customers[0].name);
            }else{
              this.saveCustomer();
            }
          }else{
              this.showAlert("Error happened, please contact the administrator");
          }
      }
      catch (error){
          console.log(error);
      }
    },   
    showCustomers(){
      this.selectedcustomers = [];
      this.toggle = true;
      this.showAddCustomer = false;
      this.showInvoices = false;
      this.showPayments = false;

    },
    findCustomerInvoices: async function(customer){
      this.customerJson.appId = localStorage.appId;
      this.customerJson.customerId = customer.id;
      try{
          
          let dataURL = this.apiURL+'Customers/findCustomerSoa';

          let response = await axios.post(dataURL, this.customerJson);
          if(response.data.status === 'success'){
            this.selectedcustomers = [];
            this.selectedcustomers.push(customer);
            //this.customer_payments.push({"orderId":"1000", "paymentType":"cash", "amount":"12.25", "paymentDate":"01-05-2022", "paid_by":"ahmad"});
            for(let i = 0 ; i < response.data.results.length;i++){
              this.balances[i+1] = this.balances[i] + parseFloat(response.data.results[i]['Debit']) - parseFloat(response.data.results[i]['Credit']);
            }
            
            this.customer_invoices = response.data.results;
            this.invoices_total = response.data.invoices_total;
            if(this.customer_invoices.length > 0){
              this.toggle = false;
              this.showAddCustomer = false;
              this.showInvoices = true;
              this.showPayments = false;

            }else{
              this.showAlert("There are no invoices for this customer");
            }
          }
      }
      catch (error){
          console.log(error);
      }
    }, 

    
    findCustomerByCond: async function(){
      this.customersJson.appId = localStorage.appId;
      this.customersJson.customer = this.findcustomer;
      try{
          let dataURL = this.apiURL+'Customers/getCustomersByCondNew';
          let response = await axios.post(dataURL, this.customersJson);  
          if(response.data.status === 'success'){
            this.customers = response.data.results.customers;
          }
      }
      catch (error){
          console.log(error);
      }
    },   

    getCustomerAddresses: async function(customerid){
      //let customersJson = {};      
      this.customersJson.appId = localStorage.appId;
      //this.customersJson.appId = "7";           
      this.customersJson.customerid = customerid;
      let customersJson_ = JSON.stringify(this.customersJson);
      try{
          
          let dataURL = this.apiURL+'Customers/getCustomerAddresses';

          let response = await axios.post(dataURL, customersJson_);  
          if(response.data.status === 'success'){
            this.customerAddresses = response.data.results.customersAddresses;
          this.addressid = this.customerAddresses[0].id;
          this.addressLine1 = this.customerAddresses[0].line;
          this.addressLine2 = this.customerAddresses[0].line1;
          this.addressArea = this.customerAddresses[0].area;
          this.addressCity = this.customerAddresses[0].city;
          this.isDefault = this.customerAddresses[0].is_default;

            this.showAddress = true;
          }else{
            this.showAddress = true;
            this.customerAddresses = [];
          }
      }
      catch (error){
          console.log(error);
      }
    },   
    getLogo: async function(){
        try{            
            let dataURL = this.apiURL+'Orders/getInvoiceLogo';
            let logoJson = {"appId": localStorage.appId};
            let response = await axios.post(dataURL, logoJson); 
            if(response.data.status === 'success'){
                this.logoUrl=response.data.results.logourl;
            }
        }
        catch (error){
            console.log(error);
        }
      },  
        
      getCustomerByTin: async function()
      {
        try{   
          this.disabled = !this.disabled;         
            let dataURL = `${this.apiURL}Customers/getCustomerByTin`;
            let tinJson = {"appId": localStorage.appId, "customer_tin  ": this.tin};
            let response = await axios.post(dataURL, tinJson); 
            if(response.data.status === 'success'){
                this.name = response.data.results.name;
                this.business_name = response.data.results.business_name;
                this.type = response.data.results.customer_type;
                this.email = response.data.results.email;
                this.phone = response.data.results.phone;
                this.addressLine1 = response.data.results.addressLine1;
                this.addressLine2 = response.data.results.addressLine2;
                this.addressArea = response.data.results.addressArea; 
                this.dis_percentage = response.data.results.dis_percentage;
                this.addressCity = response.data.results.addressCity;
                this.gender = response.data.results.gender;
            }
          
        }
        catch (error){
            console.log(error);
        }
      }
      

    }
  }
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #EEEEEE;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC; */
}
.grid-container-element { 
    display: grid; 
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr; 
    grid-gap: 10px; 
    border: 1px solid whitesmoke; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    width: 100%; 
} 
.grid-child-element_ { 
    margin: 10px; 
    border: 1px solid red; 
}
.grid-child-element { 
    margin: 2px; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    padding : 0 px;
    
}

.form-control {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 6px;
  padding: 10px;
}


/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Input group to keep input and button on same row */
.input-groups { display: flex; gap: 0.5rem; align-items: center; }
.input-groups .form-control { flex: 1; min-width: 0; }
.input-groups .btn { white-space: nowrap; }

.customers-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Card */
.customer-card {
  background: var(--theme-bg-end);
  padding: 20px;
  border-radius: 16px;
  border: var( --theme-primary) 1px solid ;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  transition: 0.3s ease;
}

.customer-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(0,0,0,0.35);
}

/* Grid */
.customer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

/* Label */
.label {
  display: block;
  font-size: 1.8rem;
  color: rgb(255,255,255);
  margin-bottom: 4px;
}

/* Value */
.labels {
  display: block;
  font-size: 1.5rem;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}

/* Balance highlight */
.balance .value {
  color: var( --theme-primary);
  font-weight: 600;
}

</style>
